import { render, staticRenderFns } from "./publishResultStatis.vue?vue&type=template&id=3ed3f31c&scoped=true&"
import script from "./publishResultStatis.vue?vue&type=script&lang=js&"
export * from "./publishResultStatis.vue?vue&type=script&lang=js&"
import style0 from "./publishResultStatis.vue?vue&type=style&index=0&id=3ed3f31c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed3f31c",
  null
  
)

export default component.exports